<template>
  <v-row>
    <v-col
        cols="12"
    >
      <h3>
        Výplaty
      </h3>

      <p>
        {{ Bilance.totalWages|currency('€') }}

        <template
            v-if="Bilance.totalWagesBank || Bilance.totalWagesCash"
        >
          <br/>

          <small>
            <template
                v-if="Bilance.totalWagesBank"
            >
              <v-icon
                  color="primary"
              >
                mdi-bank-transfer
              </v-icon>

              {{ Bilance.totalWagesBank|currency('€') }}
            </template>

            <template
                v-if="Bilance.totalWagesCash"
            >
              <v-icon
                  color="primary"
              >
                mdi-cash
              </v-icon>

              {{ Bilance.totalWagesCash|currency('€') }}
            </template>
          </small>
        </template>
      </p>

      <IsEmptyHelper
          :value="Bilance.bilanceWages.length > 0"
          if-no="table"
          if-yes="p"
          :no-gutters="true"
      >
        <thead>
          <tr>
            <th
                width="2.5%"
            >
              <v-checkbox
                  v-model="all"
                  :dense="true"
                  hide-details="auto"
                  @change="(value) => {
                    ids = []

                    total = 0

                    if (value) {
                      Bilance.bilanceWages.forEach((_BilanceWage) => {
                        ids.push(_BilanceWage.id)

                        total += _BilanceWage.total
                      })
                    }
                  }"
              />
            </th>

            <th
                width="10%"
                align="left"
            >
              Dátum
            </th>

            <th
                width="70%"
                align="left"
            >
              Názov
            </th>

            <th
                width="10%"
                align="left"
            >
              Suma
            </th>

            <th
                width="7.5%"
                align="left"
            >
              Platba
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
              v-for="(_BilanceWage) in Bilance.bilanceWages"
              :key="_BilanceWage.id"
              valign="top"
          >
            <td>
              <v-checkbox
                  v-model="ids"
                  :value="_BilanceWage.id"
                  :dense="true"
                  hide-details="auto"
                  @change="() => {
                    if (ids.length === Bilance.bilanceWages.length) {
                      all = true
                    } else {
                      all = false
                    }

                    if (ids.includes(_BilanceWage.id)) {
                      total += _BilanceWage.total
                    } else {
                      total -= _BilanceWage.total
                    }
                  }"
              />
            </td>

            <td>
              <IsEmptyHelper
                  :value="_BilanceWage.paidAt"
                  if-no="span"
                  if-yes="span"
              >
                {{ _BilanceWage.paidAt|moment('DD.MM.YYYY') }}
              </IsEmptyHelper>
            </td>

            <td>
              {{ _BilanceWage.userName }} za
              <IsEmptyHelper
                  :value="_BilanceWage.wageClosedAt"
                  if-no="span"
                  if-yes="span"
                  empty="Neuzavreté"
              >
                {{ _BilanceWage.wageClosedAt|moment('MM/YYYY') }}
              </IsEmptyHelper>
            </td>

            <td>
              {{ _BilanceWage.total|currency('€') }}
            </td>

            <td>
              <IsEmptyHelper
                  :value="_BilanceWage.pay"
                  if-no="span"
                  if-yes="span"
              >
                {{ payList[_BilanceWage.pay]?.text }}
              </IsEmptyHelper>
            </td>
          </tr>
        </tbody>

        <tfoot
            v-if="ids.length > 0"
        >
          <tr>
            <th
                align="left"
                :colspan="3"
            />

            <th
                align="left"
            >
              {{ total|currency('€') }}
            </th>

            <th
                align="left"
                :colspan="2"
            />
          </tr>
        </tfoot>
      </IsEmptyHelper>
    </v-col>
  </v-row>
</template>

<script>
  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  export default {
    name: 'Wages',
    props: [
      'Bilance'
    ],
    components: {
      IsEmptyHelper
    },
    data() {
      return {
        all: false,
        ids: [],
        total: 0
      }
    },
    computed: {
      statusList: function () {
        return this.$store.state.core.Entity.BilanceWage?.status
      },
      payList: function () {
        return this.$store.state.core.Entity.BilanceWage?.pay
      }
    }
  }
</script>
